import { isFinite } from 'lodash';
import { WebTestTooltip } from '../../tooltip/types';

const webTestMetric = (key, label, color) => ({
    key,
    label,
    color,
    units: 's',
    multiplier: 3,
    forceDecimals: true,
});

const degradedMetricDef = {
    hidden: true,
    threshold: 'degraded',
    key: 'th_m2_degraded',
    label: 'Degraded Threshold',
    color: 'yellow',
    units: 's',
    multiplier: 3,
    forceDecimals: true,
};

const excessiveMetricDef = {
    hidden: true,
    threshold: 'excessive',
    key: 'th_m2_excessive',
    label: 'Excessive Threshold',
    color: 'orange',
    units: 's',
    multiplier: 3,
    forceDecimals: true,
};

const defaultThresholds = {
    degraded: 10,
    critical: 30,
};

export const webTestChartDef = {
    tooltip: WebTestTooltip,
    chartType: 'areaspline',
    yAxis: [
        {
            title: {
                text: 'Delay (s)',
            },
        },
    ],
    statusMetric: 'status',
    metricMapping: (value) => {
        if (value === null) return null;
        if (!isFinite(value)) return undefined;

        return value / 1000;
    },
    stacking: 'normal',
    chartTrends: [
        webTestMetric('avgDns', 'DNS', '#67DC6A'),
        webTestMetric('avgNetwork', 'Network', '#7F6FC5'),
        webTestMetric('avgSsl', 'SSL', '#FF69B4'),
        webTestMetric('avgClient', 'Client', '#00CED1'),
        webTestMetric('avgApp', 'App', '#5BA3CA'),
        webTestMetric('avgServer', 'Server', '#FF7943'),
        {
            hidden: true,
            key: 'avgResponse',
            label: 'Response',
            color: '#7cb5ec',
            units: 's',
            multiplier: 3,
            forceDecimals: true,
        },
        degradedMetricDef,
        excessiveMetricDef,
    ],
    testThresholds: {
        degraded: {
            def: degradedMetricDef,
            value: defaultThresholds.degraded,
        },
        excessive: {
            def: excessiveMetricDef,
            value: defaultThresholds.critical,
        },
    },
};

export function getWebTestChartDef(test) {
    // extract thresholds for test or testtype
    const thresholds = test?.thresholds || test?.testType?.thresholds || defaultThresholds;

    return {
        ...webTestChartDef,
        testThresholds: {
            degraded: {
                def: degradedMetricDef,
                value: thresholds.degraded,
            },
            excessive: {
                def: excessiveMetricDef,
                value: thresholds.critical,
            },
        },
    };
}
